module.exports = __webpack_public_path__ + "img/dashboard-blog.bc12f88c.svg";